export const NoDataIcon = () => (
  <svg
    aria-hidden="true"
    width="144"
    height="144"
    viewBox="0 0 144 144"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="72" cy="72" r="72" fill="#EDEBE6" />
    <circle cx="72" cy="72" r="72" fill="#EDEBE6" />
    <path
      d="M51.3333 54.6666H92.6667C94.037 54.6666 95.3511 55.211 96.3201 56.1799C97.289 57.1488 97.8333 58.463 97.8333 59.8333V94.7083H46.1667V59.8333C46.1667 58.463 46.711 57.1488 47.6799 56.1799C48.6489 55.211 49.963 54.6666 51.3333 54.6666Z"
      fill="#7D5731"
    />
    <path
      d="M92.6667 53.375H51.3333C49.6211 53.3771 47.9796 54.0581 46.7689 55.2689C45.5581 56.4796 44.8771 58.1211 44.875 59.8333V101.167C44.8771 102.879 45.5581 104.52 46.7689 105.731C47.9796 106.942 49.6211 107.623 51.3333 107.625H92.6667C94.3789 107.623 96.0204 106.942 97.2311 105.731C98.4419 104.52 99.1229 102.879 99.125 101.167V59.8333C99.1229 58.1211 98.4419 56.4796 97.2311 55.2689C96.0204 54.0581 94.3789 53.3771 92.6667 53.375ZM51.3333 55.9583H92.6667C93.6944 55.9583 94.68 56.3666 95.4067 57.0933C96.1334 57.82 96.5417 58.8056 96.5417 59.8333V84.375H82.3333C81.9908 84.375 81.6622 84.5111 81.42 84.7533C81.1777 84.9956 81.0417 85.3241 81.0417 85.6667V92.125H62.9583V85.6667C62.9583 85.3241 62.8222 84.9956 62.58 84.7533C62.3378 84.5111 62.0092 84.375 61.6667 84.375H47.4583V59.8333C47.4583 58.8056 47.8666 57.82 48.5933 57.0933C49.32 56.3666 50.3056 55.9583 51.3333 55.9583Z"
      fill="#BF8C5A"
    />
    <path
      d="M51.9999 29.1691C60.8424 48.1513 92.6414 47.1514 87.8426 33.6514C83.0437 20.1515 49.8425 57.6509 70.3425 75.1509"
      stroke="black"
      strokeDasharray="2 2"
    />
    <g clipPath="url(#clip0_31_11904)">
      <path
        d="M54.2256 26.7922C53.0807 27.2635 51.7662 26.7026 51.2137 25.5946L50.2121 23.5857C50.2121 23.5857 51.3319 23.0274 52.221 22.5841C53.3291 22.0316 54.7164 22.3748 55.3472 23.4402C56.0735 24.667 55.5439 26.2496 54.2256 26.7922Z"
        fill="#AD3381"
      />
      <path
        d="M48.7914 29.5017C47.5647 30.228 45.9821 29.6984 45.4395 28.3801C44.9682 27.2351 45.529 25.9207 46.6371 25.3682L48.646 24.3666C48.646 24.3666 49.2043 25.4864 49.6476 26.3755C50.2 27.4836 49.8569 28.8709 48.7914 29.5017Z"
        fill="#AD3381"
      />
      <path
        d="M48.26 19.6704L51.7738 26.7181C51.9894 27.1505 51.8136 27.6759 51.3812 27.8915C50.9487 28.1072 50.4233 27.9314 50.2077 27.4989L46.6939 20.4513L48.26 19.6704Z"
        fill="#444444"
      />
      <path
        d="M48.646 24.3665L46.0358 25.6679C44.45 26.4586 42.5236 25.814 41.733 24.2282L40.1713 21.096C40.1007 20.9544 40.1544 20.7787 40.2958 20.708C43.1755 19.2679 46.6891 20.4417 48.1254 23.3224L48.646 24.3665Z"
        fill="#B8A6C9"
      />
      <path
        d="M47.1939 15.0918C47.0428 15.0347 46.8747 15.1109 46.8181 15.2616C46.4866 16.1397 46.4671 16.8955 46.7615 17.8601C46.6511 17.8854 46.5416 17.9199 46.4358 17.9726C46.33 18.0254 46.2366 18.092 46.15 18.1651C45.5568 17.3494 44.9414 16.9102 44.0407 16.6464C43.8862 16.6009 43.7239 16.6894 43.6788 16.8443C43.6335 16.999 43.7221 17.1611 43.8767 17.2062C44.7102 17.4504 45.2232 17.8395 45.7774 18.6505C45.5903 19.0423 45.5731 19.5107 45.7814 19.9284C46.1402 20.648 47.0176 20.9416 47.7372 20.5829C48.4568 20.2241 48.7504 19.3466 48.3916 18.627C48.1834 18.2093 47.7989 17.9411 47.3734 17.8548C47.0593 16.9241 47.0572 16.2802 47.3638 15.4676C47.4208 15.317 47.3447 15.1487 47.1939 15.0918Z"
        fill="#444444"
      />
      <path
        d="M52.8223 22.2843L50.2121 23.5857L49.6916 22.5416C48.2553 19.6609 49.4324 16.1484 52.3155 14.7152C52.4572 14.6448 52.6298 14.7077 52.7004 14.8492L54.262 17.9815C55.0527 19.5672 54.4081 21.4937 52.8223 22.2843Z"
        fill="#B8A6C9"
      />
      <path
        d="M47.8592 28.0179C48.1475 27.8742 48.2647 27.5239 48.121 27.2356C47.9772 26.9473 47.627 26.8301 47.3387 26.9738C47.0503 27.1176 46.9331 27.4679 47.0769 27.7562C47.2206 28.0445 47.5709 28.1617 47.8592 28.0179Z"
        fill="#F5F4F7"
      />
      <path
        d="M45.124 24.493C45.7007 24.2055 45.9351 23.505 45.6476 22.9284C45.3601 22.3517 44.6595 22.1174 44.0829 22.4049C43.5063 22.6924 43.2719 23.3929 43.5594 23.9695C43.8469 24.5461 44.5474 24.7805 45.124 24.493Z"
        fill="#F5F4F7"
      />
      <path
        d="M52.4327 20.8491C53.0093 20.5616 53.2437 19.8611 52.9562 19.2845C52.6687 18.7078 51.9682 18.4734 51.3915 18.7609C50.8149 19.0484 50.5805 19.7489 50.868 20.3256C51.1555 20.9022 51.856 21.1366 52.4327 20.8491Z"
        fill="#F5F4F7"
      />
      <path
        d="M53.6017 25.1548C53.89 25.011 54.0072 24.6608 53.8635 24.3725C53.7197 24.0841 53.3695 23.9669 53.0811 24.1107C52.7928 24.2544 52.6756 24.6047 52.8194 24.893C52.9631 25.1813 53.3134 25.2985 53.6017 25.1548Z"
        fill="#F5F4F7"
      />
    </g>
    <defs>
      <clipPath id="clip0_31_11904">
        <rect
          width="14"
          height="14"
          fill="white"
          transform="translate(39 18.7468) rotate(-26.5)"
        />
      </clipPath>
    </defs>
  </svg>
)
